export default {
  props: {
    itemData: {
      type: Object,
      required: true
    }
  }
};